import { Box } from "@mui/material";
import axios from "../../api/axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LocalPrice from "../../utils/LocalPrice";
import DashboardShipmentChart from "./DashboardCharts/DashboardShipmentChart";
import DashboardGoodsChart from "./DashboardCharts/DashboardGoodsChart";
import DashboardCountriesChart from "./DashboardCharts/DashboardCountriesChart";
import DashboardCouriersChart from "./DashboardCharts/DashboardCouriersChart";
import Errors from "../../utils/Errors";
import Currency from "../../utils/CurrencySymbol";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

const DashboardShipmentCount = () => {
  const navigate = useNavigate();

  const handleButtonWalletNavigate = () => {
    navigate("/my-wallet");
  };

  const handleButtonSavingsNavigate = () => {
    navigate("/basket");
  };

  const handleButtonNewShipmentsNavigate = () => {
    navigate("/orders");
  };

  const handleButtonSupportNavigate = () => {
    navigate("/support");
  };

  const [totalBalance, setTotalBalance] = useState("0");

  const [totalCome, setTotalCome] = useState([]);
  const [totalGoods, setTotalGoods] = useState([]);
  const [totalShipmentPrice, setTotalShipmentPrice] = useState("0");
  const [bestCountries, setBestCountries] = useState([]);
  const [topCouriers, setTopCouriers] = useState([]);
  const [newShipments, setNewShipments] = useState("0");
  const [declarationDiffrence, setDeclarationDiffrence] = useState("0");
  const [unpaidBasketTotal, setUnpaidBasketTotal] = useState("0");
  const [totalCases, setTotalCases] = useState("0");

  const getData = () => {
    axios
      .get(`dashboard`)
      .then((response) => {
        setTotalBalance(response.data.data_total_balance);
        setTotalCome(response.data.data_total_endorsement_chart);
        setTotalGoods(response.data.datasets_total_percent_parcel);
        setTotalShipmentPrice(response.data.data_total_per_parcels);
        setBestCountries(response.data.data_most_popular_country);
        setTopCouriers(response.data.data_five_use_track);
        setNewShipments(response.data.data_total_new_parcel);
        setDeclarationDiffrence(response.data.data_gains_from_difference);
        setUnpaidBasketTotal(response.data.data_unpaid_total_basket_price);
        setTotalCases(response.data.data_parcels_with_cases);
      })
      .catch((error) => Errors(error));
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Box className="dashboard-shipment-count">
      <div className="shipment-count-wrapper">
        {/* Hadenka Bakiyem */}
        <div className="shipment-count-container">
          <div className="shipment-count-icon-wrapper wallet">
            <AccountBalanceWalletIcon />
          </div>
          <div className="shipment-count-text">
            <div className="shipment-count-text-total">hadenkaBakiyem</div>
            <div className="shipment-count-text-number blue">
              {LocalPrice(totalBalance)} ₺
            </div>
            <div className="shipment-count-text-footer">
              <button
                onClick={handleButtonWalletNavigate}
                className="count-button"
              >
                Detaylı İncele
              </button>
            </div>
          </div>
        </div>

        {/* Sepette Ödeme Bekleyen Tutar */}
        <div className="shipment-count-container">
          <div className="shipment-count-icon-wrapper cart">
            <ShoppingCartIcon />
          </div>
          <div className="shipment-count-text">
            <div className="shipment-count-text-total">
              Sepette Ödeme Bekleyen Tutar
            </div>
            <div
              className="shipment-count-text-number"
              style={{
                color: String(unpaidBasketTotal).includes("-")
                  ? "var(--shipmentRed)"
                  : "var(--shipmentGreen)",
              }}
            >
              {isNaN(unpaidBasketTotal) ? 0 : LocalPrice(unpaidBasketTotal)} ₺
            </div>
            <div className="shipment-count-text-footer">
              <button
                onClick={handleButtonSavingsNavigate}
                className="count-button"
              >
                Detaylı İncele
              </button>
            </div>
          </div>
        </div>

        {/* Yeni Gönderiler */}
        <div className="shipment-count-container">
          <div className="shipment-count-icon-wrapper shipping">
            <LocalShippingIcon />
          </div>
          <div className="shipment-count-text">
            <div className="shipment-count-text-total">Yeni Gönderiler</div>
            <div className="shipment-count-text-number blue">
              {newShipments}
            </div>
            <div className="shipment-count-text-footer">
              <button
                onClick={handleButtonNewShipmentsNavigate}
                className="count-button"
              >
                Detaylı İncele
              </button>
            </div>
          </div>
        </div>

        {/* Hadenka Ölçümlerinden Kazanımlarım */}
        <div className="shipment-count-container">
          <div className="shipment-count-icon-wrapper analytics">
            <AnalyticsIcon />
          </div>
          <div className="shipment-count-text">
            <div className="shipment-count-text-total">
              Hadenka Ölçümlerinden Kazanımlarım
            </div>
            <div
              className="shipment-count-text-number"
              style={{
                color: String(declarationDiffrence).includes("-")
                  ? "var(--shipmentRed)"
                  : "var(--shipmentGreen)",
              }}
            >
              {LocalPrice(declarationDiffrence)} ₺
            </div>
            <div className="shipment-count-text-footer">
            </div>
          </div>
        </div>

        {/* Ortalama Gönderi Maliyeti */}
        <div className="shipment-count-container">
          <div className="shipment-count-icon-wrapper price">
            <MonetizationOnIcon />
          </div>
          <div className="shipment-count-text">
            <div className="shipment-count-text-total">
              Ortalama Gönderi Maliyeti
            </div>
            <div className="shipment-count-text-number blue">
              {Currency("USD")}
              {LocalPrice(totalShipmentPrice)}
            </div>
            <div className="shipment-count-text-footer">
            </div>
          </div>
        </div>

        {/* Destek Dosyalarım */}
        <div className="shipment-count-container">
          <div className="shipment-count-icon-wrapper support">
            <SupportAgentIcon />
          </div>
          <div className="shipment-count-text">
            <div className="shipment-count-text-total">Destek Dosyalarım</div>
            <div className="shipment-count-text-number blue">
              {totalCases}
            </div>
            <div className="shipment-count-text-footer">
              <button
                onClick={handleButtonSupportNavigate}
                className="count-button"
              >
                Detaylı İncele
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="dashboard-shipment-line">
        <DashboardShipmentChart totalCome={totalCome} />
      </div>

      <div className="pie shipment-count-wrapper">
        <div className="dashboard-shipment-pie">
          <DashboardCouriersChart topCouriers={topCouriers} />
        </div>
        <div className="dashboard-shipment-pie">
          <DashboardGoodsChart totalGoods={totalGoods} />
        </div>
        <div className="dashboard-shipment-pie">
          <DashboardCountriesChart bestCountries={bestCountries} />
        </div>
      </div>
    </Box>

  );
};

export default DashboardShipmentCount;

